import { render, staticRenderFns } from "./ChooseTokenTipModal.vue?vue&type=template&id=34236946&scoped=true&"
import script from "./ChooseTokenTipModal.vue?vue&type=script&lang=js&"
export * from "./ChooseTokenTipModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTokenTipModal.vue?vue&type=style&index=0&id=34236946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34236946",
  null
  
)

export default component.exports